import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  return (
    <Route
      {...rest}
      render={props =>
        inProgress === InteractionStatus.None && !isAuthenticated ?
          <Redirect to='/login' />
          :
          <Component {...props} />
      }
    />
  );
};

export default PrivateRoute;
